// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arabic-search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  overflow: hidden;
  height: 78px;
  max-width: 1160px;
  width: 76%;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: 2px solid #cccccc;
  border-radius: 42px;
  background-color: #ffffff;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 900px) {
  .arabic-search-bar {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .arabic-search-bar {
    width: 95%;
  }
}

.arabic-text-input {
  background: transparent;
  flex: 1 1;
  border: none;
  padding: 5px 36px 5px 5px;
  font-family: Roboto;
  font-size: 28px;
  outline: none;
  direction: rtl;
  text-align: right;
}

.arabic-filter-styles-control {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 36px;
  margin-left: 0.7em;
}

.arabic-filter-styles-placeholder {
  font-size: 1em;
  font-weight: 400;
}

.arabic-filter-styles-option {
  background-color: #e5e5e5;
  color: #ffffff;
}

.arabic-option-arrow {
  color: #cc0000;
  height: 16px;
}

.arabic-search-icon {
  align-items: center;
  justify-content: end;
  color: #cc0000;
  height: 24px;
  padding-left: 0;
  padding-right: 24px;
  margin-right: 0.8em;
}

.arabic-search-submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.arabic-right-up-arrow {
  color: #808080;
  height: 12px;
  margin-left: 10px;
}

@media (max-width: 650px) {
  .arabic-right-up-arrow {
    display: none;
  }
}

.arabic-text-below-search-box-div {
  display: flex;
  color: #808080;
  font-size: 14px;
  line-height: 150%;
  height: 24px;
  font-family: Roboto-Slab;
  font-style: normal;
  font-weight: 400;
  margin-top: 5px;
  transform: translateX(-31%);
  margin-left: 12rem;
}

@media (max-width: 1100px) {
  .arabic-text-below-search-box-div {
    margin-right: 40px;
  }
}

.arabic-search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

.home-search-section .arabic-search-bar {
  border-radius: 48px;
  height: 92px;
  max-width: 1320px;
  width: calc(100% - 56px);
}

.home-search-section .arabic-text-input {
  font-size: 30px;
  padding-right: 40px;
}

.home-search-section .arabic-search-icon {
  height: 30px;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  color: #ffffff;
}

.home-search-section .arabic-search-submit-button {
  background: #cc0000;
  border-radius: 50%;
  flex: 0 0 64px;
  height: 64px;
  margin-right: 14px;
  width: 64px;
}

.home-search-section .arabic-search-submit-button:hover,
.home-search-section .arabic-search-submit-button:focus-visible {
  background: #a90000;
  outline: none;
}

.home-search-section .search-underbar {
  direction: ltr;
  margin-top: 14px;
  max-width: 1320px;
  width: calc(100% - 56px);
}

.home-search-section .search-hint,
.home-search-section .translation-toggle-text,
.home-search-section .translate-flow-label,
.home-search-section .lang-selector-label {
  direction: rtl;
}

.home-search-section .translation-controls {
  direction: ltr;
  justify-content: flex-end;
  min-width: 542px;
}

.home-search-section .translation-toggle-label--compact {
  flex: 0 0 260px;
}

.home-search-section .translate-flow--underbar {
  flex: 0 0 270px;
}

.home-search-section .translate-flow--underbar .lang-selector-btn {
  padding: 12px 10px 8px 32px;
}

.home-search-section .translate-flow--underbar .lang-selector-caret {
  margin-left: 0;
  margin-right: auto;
}

.home-search-section .lang-dropdown {
  left: auto;
  right: 0;
  text-align: right;
}

.home-search-section .lang-option {
  direction: ltr;
}

.home-search-section .lang-option-label {
  direction: rtl;
  unicode-bidi: isolate;
}

@media (max-width: 900px) {
  .home-search-section .translation-controls {
    min-width: 0;
  }
}

@media (max-width: 650px) {
  .home-search-section .search-underbar {
    align-items: stretch;
    flex-direction: column;
  }

  .home-search-section .search-hint,
  .home-search-section .translation-controls {
    width: 100%;
  }

  .home-search-section .translation-controls {
    flex-wrap: wrap;
  }

  .home-search-section .translation-toggle-label--compact,
  .home-search-section .translate-flow--underbar {
    flex: 1 1 100%;
  }
}

@media (max-width: 500px) {
  .home-search-section .arabic-search-bar {
    border-radius: 48px;
    height: 92px;
    width: calc(100% - 32px);
  }

}

/* Autocomplete */
.below-input {
  position: relative;
}

.autocomplete-div {
  position: absolute;
  z-index: 100;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 900px) {
  .autocomplete-div {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .autocomplete-div {
    width: 95%;
  }
}

.autocomplete-suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  position: absolute;
  z-index: 1000;
  width: 100%;
  border: 1px solid #cccccc;
  border-top: none;
  max-height: 300px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f2f2f2;
}

/* Underbar (hint near keyboard, translate opposite side) */
.search-underbar-row {
  display: flex;
  justify-content: center;
}

.search-underbar {
  max-width: 1160px;
  width: 76%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  margin-top: 6px;
}

@media (max-width: 900px) {
  .search-underbar {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .search-underbar {
    width: 95%;
  }
}

.search-hint {
  display: inline-flex;
  align-items: center;
  background: #f8f9fc;
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  color: #667085;
  cursor: pointer;
  font-size: 22px;
  gap: 12px;
  line-height: 1;
  height: 64px;
  min-height: 64px;
  width: 260px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 800;
  justify-content: center;
  padding: 0 24px;
  white-space: nowrap;
}

.search-hint-icon {
  color: #667085;
  height: 20px;
  width: 20px;
}

.search-hint p {
  margin: 0;
}

.search-hint:hover,
.search-hint:focus-visible {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
  color: #12394d;
  outline: none;
}

/* Translation Toggle */
.translation-toggle-row {
  display: flex;
  justify-content: center;
}

.translation-toggle-underbar {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}

@media (max-width: 900px) {
  .translation-toggle-underbar {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .translation-toggle-underbar {
    width: 95%;
  }
}

.translation-toggle-label {
  align-items: center;
  background: #f8f9fc;
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);
  color: #667085;
  cursor: pointer;
  direction: ltr; /* keep checkbox then text ordering */
  display: inline-flex;
  flex-direction: row;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 22px;
  font-weight: 800;
  gap: 14px;
  min-height: 64px;
  min-width: 260px;
  padding: 0 24px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.translation-toggle-label:hover {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
  color: #12394d;
}

.translation-toggle-label:focus-within {
  background: #eef7fa;
  border-color: #9dbac3;
  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);
}

.translation-toggle-label--compact {
  order: 2;
}

.translate-flow--underbar {
  order: 1;
}

.translation-toggle-label-rtl {
  padding-left: 12px; /* inset from left edge (RTL page) */
}

.translation-toggle-label-rtl .translation-toggle-checkbox {
  cursor: pointer;
  height: 1px;
  margin: 0;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.translation-toggle-icon {
  color: #667085;
  height: 24px;
  order: 1;
}

.translation-toggle-switch {
  background: #d5dbe5;
  border-radius: 999px;
  display: inline-flex;
  flex: 0 0 54px;
  height: 30px;
  order: 3;
  position: relative;
  transition: background-color 160ms ease;
}

.translation-toggle-switch::after {
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  content: "";
  height: 22px;
  left: 4px;
  position: absolute;
  top: 4px;
  transition: transform 160ms ease;
  width: 22px;
}

.translation-toggle-checkbox:checked ~ .translation-toggle-switch {
  background: #cc0000;
}

.translation-toggle-label:hover .translation-toggle-switch,
.translation-toggle-label:focus-within .translation-toggle-switch {
  background: #c5d2dc;
}

.translation-toggle-label:hover .translation-toggle-checkbox:checked ~ .translation-toggle-switch,
.translation-toggle-label:focus-within .translation-toggle-checkbox:checked ~ .translation-toggle-switch {
  background: #a90000;
}

.translation-toggle-checkbox:checked ~ .translation-toggle-switch::after {
  transform: translateX(24px);
}

.translation-toggle-text {
  color: #667085;
  font-size: inherit;
  order: 2;
  direction: rtl; /* render Arabic text correctly */
  unicode-bidi: isolate;
}

.translation-toggle-label:hover .translation-toggle-icon,
.translation-toggle-label:hover .translation-toggle-text,
.translation-toggle-label:focus-within .translation-toggle-icon,
.translation-toggle-label:focus-within .translation-toggle-text {
  color: #12394d;
}

@media (max-width: 650px) {
  .search-hint {
    white-space: normal;
  }
}

.translation-toggle-label:hover .translation-toggle-text {
  color: #12394d;
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/search-input.rtl.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;EAC1B;;AAEF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,cAAc,EAAE,qCAAqC;EACrD,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc,EAAE,iCAAiC;EACjD,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".arabic-search-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  direction: ltr;\n  overflow: hidden;\n  height: 78px;\n  max-width: 1160px;\n  width: 76%;\n  border-top: 0;\n  border-right: 0;\n  border-left: 0;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 42px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media (max-width: 900px) {\n  .arabic-search-bar {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .arabic-search-bar {\n    width: 95%;\n  }\n}\n\n.arabic-text-input {\n  background: transparent;\n  flex: 1;\n  border: none;\n  padding: 5px 36px 5px 5px;\n  font-family: Roboto;\n  font-size: 28px;\n  outline: none;\n  direction: rtl;\n  text-align: right;\n}\n\n.arabic-filter-styles-control {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  margin-left: 0.7em;\n}\n\n.arabic-filter-styles-placeholder {\n  font-size: 1em;\n  font-weight: 400;\n}\n\n.arabic-filter-styles-option {\n  background-color: #e5e5e5;\n  color: #ffffff;\n}\n\n.arabic-option-arrow {\n  color: #cc0000;\n  height: 16px;\n}\n\n.arabic-search-icon {\n  align-items: center;\n  justify-content: end;\n  color: #cc0000;\n  height: 24px;\n  padding-left: 0;\n  padding-right: 24px;\n  margin-right: 0.8em;\n}\n\n.arabic-search-submit-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n}\n\n.arabic-right-up-arrow {\n  color: #808080;\n  height: 12px;\n  margin-left: 10px;\n}\n\n@media (max-width: 650px) {\n  .arabic-right-up-arrow {\n    display: none;\n  }\n}\n\n.arabic-text-below-search-box-div {\n  display: flex;\n  color: #808080;\n  font-size: 14px;\n  line-height: 150%;\n  height: 24px;\n  font-family: Roboto-Slab;\n  font-style: normal;\n  font-weight: 400;\n  margin-top: 5px;\n  transform: translateX(-31%);\n  margin-left: 12rem;\n}\n\n@media (max-width: 1100px) {\n  .arabic-text-below-search-box-div {\n    margin-right: 40px;\n  }\n}\n\n.arabic-search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n.home-search-section .arabic-search-bar {\n  border-radius: 48px;\n  height: 92px;\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n.home-search-section .arabic-text-input {\n  font-size: 30px;\n  padding-right: 40px;\n}\n\n.home-search-section .arabic-search-icon {\n  height: 30px;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n  color: #ffffff;\n}\n\n.home-search-section .arabic-search-submit-button {\n  background: #cc0000;\n  border-radius: 50%;\n  flex: 0 0 64px;\n  height: 64px;\n  margin-right: 14px;\n  width: 64px;\n}\n\n.home-search-section .arabic-search-submit-button:hover,\n.home-search-section .arabic-search-submit-button:focus-visible {\n  background: #a90000;\n  outline: none;\n}\n\n.home-search-section .search-underbar {\n  direction: ltr;\n  margin-top: 14px;\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n.home-search-section .search-hint,\n.home-search-section .translation-toggle-text,\n.home-search-section .translate-flow-label,\n.home-search-section .lang-selector-label {\n  direction: rtl;\n}\n\n.home-search-section .translation-controls {\n  direction: ltr;\n  justify-content: flex-end;\n  min-width: 542px;\n}\n\n.home-search-section .translation-toggle-label--compact {\n  flex: 0 0 260px;\n}\n\n.home-search-section .translate-flow--underbar {\n  flex: 0 0 270px;\n}\n\n.home-search-section .translate-flow--underbar .lang-selector-btn {\n  padding: 12px 10px 8px 32px;\n}\n\n.home-search-section .translate-flow--underbar .lang-selector-caret {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.home-search-section .lang-dropdown {\n  left: auto;\n  right: 0;\n  text-align: right;\n}\n\n.home-search-section .lang-option {\n  direction: ltr;\n}\n\n.home-search-section .lang-option-label {\n  direction: rtl;\n  unicode-bidi: isolate;\n}\n\n@media (max-width: 900px) {\n  .home-search-section .translation-controls {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 650px) {\n  .home-search-section .search-underbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .home-search-section .search-hint,\n  .home-search-section .translation-controls {\n    width: 100%;\n  }\n\n  .home-search-section .translation-controls {\n    flex-wrap: wrap;\n  }\n\n  .home-search-section .translation-toggle-label--compact,\n  .home-search-section .translate-flow--underbar {\n    flex: 1 1 100%;\n  }\n}\n\n@media (max-width: 500px) {\n  .home-search-section .arabic-search-bar {\n    border-radius: 48px;\n    height: 92px;\n    width: calc(100% - 32px);\n  }\n\n}\n\n/* Autocomplete */\n.below-input {\n  position: relative;\n}\n\n.autocomplete-div {\n  position: absolute;\n  z-index: 100;\n  width: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n@media (max-width: 900px) {\n  .autocomplete-div {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .autocomplete-div {\n    width: 95%;\n  }\n}\n\n.autocomplete-suggestions {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: white;\n  position: absolute;\n  z-index: 1000;\n  width: 100%;\n  border: 1px solid #cccccc;\n  border-top: none;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.suggestion-item {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n  cursor: pointer;\n}\n\n.suggestion-item:hover {\n  background-color: #f2f2f2;\n}\n\n/* Underbar (hint near keyboard, translate opposite side) */\n.search-underbar-row {\n  display: flex;\n  justify-content: center;\n}\n\n.search-underbar {\n  max-width: 1160px;\n  width: 76%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 22px;\n  margin-top: 6px;\n}\n\n@media (max-width: 900px) {\n  .search-underbar {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .search-underbar {\n    width: 95%;\n  }\n}\n\n.search-hint {\n  display: inline-flex;\n  align-items: center;\n  background: #f8f9fc;\n  border: 1px solid #e2e7ef;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  box-sizing: border-box;\n  color: #667085;\n  cursor: pointer;\n  font-size: 22px;\n  gap: 12px;\n  line-height: 1;\n  height: 64px;\n  min-height: 64px;\n  width: 260px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 800;\n  justify-content: center;\n  padding: 0 24px;\n  white-space: nowrap;\n}\n\n.search-hint-icon {\n  color: #667085;\n  height: 20px;\n  width: 20px;\n}\n\n.search-hint p {\n  margin: 0;\n}\n\n.search-hint:hover,\n.search-hint:focus-visible {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n  color: #12394d;\n  outline: none;\n}\n\n/* Translation Toggle */\n.translation-toggle-row {\n  display: flex;\n  justify-content: center;\n}\n\n.translation-toggle-underbar {\n  width: 50%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 6px;\n}\n\n@media (max-width: 900px) {\n  .translation-toggle-underbar {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .translation-toggle-underbar {\n    width: 95%;\n  }\n}\n\n.translation-toggle-label {\n  align-items: center;\n  background: #f8f9fc;\n  border: 1px solid #e2e7ef;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.08);\n  color: #667085;\n  cursor: pointer;\n  direction: ltr; /* keep checkbox then text ordering */\n  display: inline-flex;\n  flex-direction: row;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  gap: 14px;\n  min-height: 64px;\n  min-width: 260px;\n  padding: 0 24px;\n  position: relative;\n  user-select: none;\n}\n\n.translation-toggle-label:hover {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n  color: #12394d;\n}\n\n.translation-toggle-label:focus-within {\n  background: #eef7fa;\n  border-color: #9dbac3;\n  box-shadow: 0 4px 14px rgba(18, 57, 77, 0.14);\n}\n\n.translation-toggle-label--compact {\n  order: 2;\n}\n\n.translate-flow--underbar {\n  order: 1;\n}\n\n.translation-toggle-label-rtl {\n  padding-left: 12px; /* inset from left edge (RTL page) */\n}\n\n.translation-toggle-label-rtl .translation-toggle-checkbox {\n  cursor: pointer;\n  height: 1px;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.translation-toggle-icon {\n  color: #667085;\n  height: 24px;\n  order: 1;\n}\n\n.translation-toggle-switch {\n  background: #d5dbe5;\n  border-radius: 999px;\n  display: inline-flex;\n  flex: 0 0 54px;\n  height: 30px;\n  order: 3;\n  position: relative;\n  transition: background-color 160ms ease;\n}\n\n.translation-toggle-switch::after {\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);\n  content: \"\";\n  height: 22px;\n  left: 4px;\n  position: absolute;\n  top: 4px;\n  transition: transform 160ms ease;\n  width: 22px;\n}\n\n.translation-toggle-checkbox:checked ~ .translation-toggle-switch {\n  background: #cc0000;\n}\n\n.translation-toggle-label:hover .translation-toggle-switch,\n.translation-toggle-label:focus-within .translation-toggle-switch {\n  background: #c5d2dc;\n}\n\n.translation-toggle-label:hover .translation-toggle-checkbox:checked ~ .translation-toggle-switch,\n.translation-toggle-label:focus-within .translation-toggle-checkbox:checked ~ .translation-toggle-switch {\n  background: #a90000;\n}\n\n.translation-toggle-checkbox:checked ~ .translation-toggle-switch::after {\n  transform: translateX(24px);\n}\n\n.translation-toggle-text {\n  color: #667085;\n  font-size: inherit;\n  order: 2;\n  direction: rtl; /* render Arabic text correctly */\n  unicode-bidi: isolate;\n}\n\n.translation-toggle-label:hover .translation-toggle-icon,\n.translation-toggle-label:hover .translation-toggle-text,\n.translation-toggle-label:focus-within .translation-toggle-icon,\n.translation-toggle-label:focus-within .translation-toggle-text {\n  color: #12394d;\n}\n\n@media (max-width: 650px) {\n  .search-hint {\n    white-space: normal;\n  }\n}\n\n.translation-toggle-label:hover .translation-toggle-text {\n  color: #12394d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
